module.exports = "<p class=\"mt-5\">\r\n  welcome\r\n</p>"